import { Component, computed, effect, inject } from '@angular/core';
import { ProgressBar } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { TransportExportRetrievalService } from '../../services/transport-export-retrieval.service';
import { ByteFormatPipe } from './byte-format.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';

@Component({
  selector: 'transport-export-progress-dialog',
  imports: [ProgressBar, ByteFormatPipe, ButtonModule, TranslatePipe],
  templateUrl: './export-progress-dialog.component.html',
  styleUrl: './export-progress-dialog.component.scss',
})
export class ExportProgressDialogComponent {
  private readonly dialogRef = inject(DynamicDialogRef);
  private readonly transportExportRetrievalService = inject(TransportExportRetrievalService);

  private readonly dialogClosing = toSignal(this.dialogRef.onClose.pipe(map(() => true)), { initialValue: false });

  constructor() {
    effect(() => {
      const closing = this.dialogClosing();
      this.transportExportRetrievalService.aborted.set(closing);
    });
  }

  protected readonly currentBytes = computed(() => {
    return this.transportExportRetrievalService.currentProgress();
  });

  protected readonly estimatedMaxBytes = computed(() => {
    return this.transportExportRetrievalService.estimatedMaxProgress();
  });

  protected readonly currentProgress = computed(() => {
    const current = this.currentBytes();
    const max = this.estimatedMaxBytes();

    if (current === 0 || max === 0) {
      return 0;
    }

    return Math.ceil((current / max) * 100);
  });

  protected cancelExport() {
    this.dialogRef.close(false);
  }
}
